import BaseApi from "../../../services/Api";
import Swal from "sweetalert2";
import React, {useContext, useEffect, useState} from "react";
import Tooltip from "../../Popups/Tooltip";
import {Modal, Spinner} from "react-bootstrap";
import style from './style.module.css';
import { intervalToDuration, formatDuration } from "date-fns";
import ptBR from 'date-fns/locale/pt-BR';
import { useRef } from 'react';
import paws from "../../../images/patinhas6.svg"
import { ModalContext } from "src/context/ModalContext";

import {Swiper, SwiperSlide} from 'swiper/react'
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import AdoptModal from "./Adopt"

const AnimalsInfo=({ children, idAnimal })=>{
  const [isLoading, setLoading] = React.useState(true);
  const [isShow, setShowModal] = React.useState(false);

  const [isPinned, setIsPinned] = useState(false);
  const [name, setName] = useState('');
  const [species, setSpecies] = useState('');
  const [description, setDescription] = useState('');
  const [animal_img, setAnimalImage] = useState(null);
  const [sex, setSex] = useState('');
  const [isCastrated, setIsCastrated] = useState(false);
  const [breed, setBreed] = useState('');
  const [birthday, setBirthday] = useState(null);
  const [size, setSize] = useState('');
  const [isSpecial, setSpecial] = useState('');
  const [wasAdopted, setWasAdopted] = useState(false);
  const [animalImages, setAnimalImages] = useState(null);
  const [modalChoice, setModalChoice] = useState('description');
  let controller = new AbortController();







  const refShow = useRef();
  const showNextModal = () => {
    refShow.current.style.display = "none";
  }

  const handleClose = () => {
    setShowModal(false);
  }

  const requestData = () => {
    setLoading(true);
    BaseApi.get(`/animais_nadotados${idAnimal ? `/${idAnimal}` : ''}`).then(res => {
      let data = res.data.data[0];
      console.log(data)

      setIsPinned(data.is_pinned);
      setName(data.name);
      setSpecies(data.species);
      setDescription(data.description);
      setWasAdopted(data.was_adopted);
      setAnimalImage(data.animal_img);
      setSex(data.sex);
      setIsCastrated(data.is_castrated);
      setBreed(data.breed);
      setBirthday(data.birthday);
      setSize(data.size);
      setSpecial(data.special_animal);
      setAnimalImages(data.animal_image)
      setLoading(false);

    }).catch(err => {
      console.log(err);
      Swal.fire('Oops!', err?.data?.errors?.[0] || err?.data?.message || 'Ocorreu um erro ao carregar as informações deste animal, ele não foi encontrado ou já foi adotado.', 'error');
      setShowModal(false);
    })
  }


  const handleDate = (birthday) => {
    const todayDate = new Date();
    const birthdayDate = new Date(birthday);

    let duration = intervalToDuration({
      start: birthdayDate,
      end: todayDate,
    });
    if (duration.years === 0 && duration.months > 0) {
      if(duration.months == 1){
        return `${duration.months} mes`;

      }else{
        return `${duration.months} meses`;

      }
    } else

    {
      if(duration.years==0 && duration.months == 0){
        if(duration.days == 1){
          return `${duration.days} dia`;
        }else{
          return `${duration.days} dias`;
        }
      }else{
        return formatDuration(duration, {
          format: ['years'],
          delimiter: ' e ',
          locale: ptBR
        });
      }

    }
  }

  const {isModal, toggleIsModal} = useContext(ModalContext)


  useEffect(() => {
    controller = new AbortController();
    if(isShow) {
      requestData();
    } else {

      setIsPinned(false);
      setName('')
      setSpecies('');
      setDescription('');
      setWasAdopted(false);
      setAnimalImage(null);
      setSex('');
      setIsCastrated(false);
      setBreed('');
      setBirthday('');
      setSize('');
      setLoading(true);
     

    }
    return () => {
      controller.abort();
      setLoading(true);
  };
  }, [isShow])

  const hideNavbar = () => {
    if(isModal == false) toggleIsModal()
  }

  return(
      <>
        {children &&
            React.cloneElement(children, { onClick: (e) => setShowModal(true) })}
        {!children && (
            <Tooltip text={"Informações do Animal"}>
              <button
                  className={`btn btn-${idAnimal ? "warning" : ""} text-white fa-bold`}
                  onClick={(e) => setShowModal(true)}
              >
                <i className={`bi bi-${idAnimal ? "person-gear" : "plus"}`}></i>
              </button>
            </Tooltip>
        )}

            <Modal
                dialogClassName={style.modalInfo}
                centered
                scrollable
                onHide={handleClose}
                show={isShow}
                animation={true}
                size="md"
            >
              <Modal.Body className={style.animals}>
                {isLoading && (
                    <>
                      <img src={paws} className={style.paws}/>
                      <Spinner animation="border" role="status" className={style.spinner}>
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    </>
                )}
                { !isLoading && modalChoice == "description" &&(
                    <>
                      <img src={paws} className={style.paws}/>
                      <h1 className={style.name}>{`Conheça ${sex == "male" ? "o" : "a"} ${name}`}</h1>
                      <main>
                        <article className={style.information}>
                          <div className={style.labels_wrapper}>
                            <label>{species == "dog" ? "Cachorro": species == "cat" ? "Gato":""}</label>
                            <label>{breed}</label>
                            <label>{sex == "female" ? "Fêmea": sex == "male" ? "Macho": "indefinido"}</label>
                            {isSpecial=="1" && (
                                <label>Especial</label>
                            )}
                            <label>Porte {size == "small" ? "pequeno": size == "medium" ? "médio": "grande"}</label>
                            <label>{isCastrated == "0" ? "Não é castrad": isCastrated == "1" ? "É castrad" : ""}{sex=="male" ? "o" : sex=="female" ? "a" : ""}</label>
                            <label htmlFor="">{handleDate(birthday)}</label>
                          </div>
                          <p className={style.description}>{description}</p>
                        </article>
                        <aside className={style.img}>
                          <Swiper
                              slidesPerView={1}
                              pagination={{
                                clickable: true,
                              }}
                              navigation = {true}
                              className={style.swiperEdit}
                          >
                            <SwiperSlide key={1} className={style.swiperSlide}>
                              <img src={animal_img} alt="Slider" className={style.slide_item}/>
                            </SwiperSlide>
                            {animalImages.map((item)=>
                                (
                                    <SwiperSlide key={item.id+1}  className={style.swiperSlide}>
                                      <img src={item.image} alt="Slider" className={style.slide_item} />
                                    </SwiperSlide>
                                )
                            )}
                          </Swiper>
                        </aside>
                      </main>

                      {!isLoading && (
                          <div className={style.buttons}>
                            <button
                                onClick={(e)=>setModalChoice("adopt")}
                                className={style.btn}
                            >ADOTAR</button>




                            <button
                                id ="buttonsuitor"
                                className={style.btn}
                                onClick={(e)=>setModalChoice("home")}
                            >LAR TEMPORÁRIO</button>


                            <button
                                className={style.btn}
                                onClick={handleClose}
                            >VOLTAR</button>
                          </div>
                      )}
                    </>
                )}

                { !isLoading && (modalChoice == "adopt"||modalChoice=="home") &&
                    (

                        <AdoptModal
                            choiceAnimal={modalChoice}
                            idAnimal={idAnimal}
                            onBack={()=>setModalChoice("description")}
                            closeModal={() => setShowModal(false) }
                        />

                    ) }

              </Modal.Body>
            </Modal>

      </>
  )
}
export default AnimalsInfo